export default __webpack_public_path__ + "static/data-viz-bg-2b95b3e84c49f1f6c1b2441d7c5fadb4.jpg";